<template>
  <div class="base-checkbox-group">
    <el-checkbox-group
      v-model="checkboxValue"
      @change="handleCheckboxChange"
    >
      <el-checkbox
        v-for="option in options"
        :key="option[defaultProps.value] || option.value"
        :label="option[defaultProps.label] || option.label"
        :disabled="option.disabled"
        v-bind="checkboxAttrs"
        v-on="$listeners"
      >
        {{ option[defaultProps.value] || option.value }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckboxGroup',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    defaultProps: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'key'
      })
    },
    checkboxAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    handleCheckboxChange(value) {
      this.$emit('update:value', value)
    }
  }
}
</script>
<style lang="scss" scoped></style>
